// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArchiveController from "./archive_controller"
application.register("archive", ArchiveController)

import ArchiveLayoutController from "./archive_layout_controller"
application.register("archive-layout", ArchiveLayoutController)

import BannerBrowserController from "./banner_browser_controller"
application.register("banner-browser", BannerBrowserController)

import BlindTownhallConfirmController from "./blind_townhall_confirm_controller"
application.register("blind-townhall-confirm", BlindTownhallConfirmController)

import BlindTownhallShowDashboardController from "./blind_townhall_show_dashboard_controller"
application.register("blind-townhall-show-dashboard", BlindTownhallShowDashboardController)

import BordaDashboardController from "./borda_dashboard_controller"
application.register("borda-dashboard", BordaDashboardController)

import CommentDashboardChannelController from "./comment_dashboard_channel_controller"
application.register("comment-dashboard-channel", CommentDashboardChannelController)

import CommentDashboardHotAutoreloadController from "./comment_dashboard_hot_autoreload_controller"
application.register("comment-dashboard-hot-autoreload", CommentDashboardHotAutoreloadController)

import CustomFormController from "./custom_form_controller"
application.register("custom-form", CustomFormController)

import DashboardNavController from "./dashboard_nav_controller"
application.register("dashboard-nav", DashboardNavController)

import DownloadController from "./download_controller"
application.register("download", DownloadController)

import DownloadScreenshotController from "./download_screenshot_controller"
application.register("download-screenshot", DownloadScreenshotController)

import DropdownNavController from "./dropdown_nav_controller"
application.register("dropdown-nav", DropdownNavController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FilterHelperController from "./filter_helper_controller"
application.register("filter-helper", FilterHelperController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FlatpickrRangeController from "./flatpickr_range_controller"
application.register("flatpickr-range", FlatpickrRangeController)

import ImageMorelessController from "./image_moreless_controller"
application.register("image-moreless", ImageMorelessController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import IntroductionController from "./introduction_controller"
application.register("introduction", IntroductionController)

import InvoiceFormController from "./invoice_form_controller"
application.register("invoice-form", InvoiceFormController)

import MainController from "./main_controller"
application.register("main", MainController)

import MeetingCardController from "./meeting_card_controller"
application.register("meeting-card", MeetingCardController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MenuOpenController from "./menu_open_controller"
application.register("menu-open", MenuOpenController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultichoicevoteDashboardController from "./multichoicevote_dashboard_controller"
application.register("multichoicevote-dashboard", MultichoicevoteDashboardController)

import AttendanceDashboardController from "./attendance_dashboard_controller"
application.register("attendance-dashboard", AttendanceDashboardController)

import NavbarCollapseController from "./navbar_collapse_controller"
application.register("navbar-collapse", NavbarCollapseController)

import OptionController from "./option_controller"
application.register("option", OptionController)

import SessionValidationController from "./session_validation_controller"
application.register("session-validation", SessionValidationController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SortableNestedFormController from "./sortable_nested_form_controller"
application.register("sortable-nested-form", SortableNestedFormController)

import StatusItemController from "./status_item_controller"
application.register("status-item", StatusItemController)

import StatusMeetingController from "./status_meeting_controller"
application.register("status-meeting", StatusMeetingController)

import TopBannerController from "./top_banner_controller"
application.register("top-banner", TopBannerController)

import TownhallConfirmController from "./townhall_confirm_controller"
application.register("townhall-confirm", TownhallConfirmController)

import UserInfoController from "./user_info_controller"
application.register("user-info", UserInfoController)

import UserValidationController from "./user_validation_controller"
application.register("user-validation", UserValidationController)

import VideoContentController from "./video_content_controller"
application.register("video-content", VideoContentController)

import TurboController from "./turbo_controller"
application.register("turbo", TurboController)

import NestedForm from 'stimulus-rails-nested-form'
application.register('nested-form', NestedForm)

import TabsController from "./tabs_controller"
application.register("tabs",TabsController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutoviewportController from "./autoviewport_controller"
application.register("autoviewport", AutoviewportController)

import RandomSubmitController from "./random_submit_controller"
application.register("random-submit", RandomSubmitController)

import UserRowController from "./user_row_controller"
application.register("user-row", UserRowController)

import JudgegroupController from "./judgegroup_controller"
application.register("judgegroup", JudgegroupController)

import BordaBudgetController from "./borda_budget_controller"
application.register("borda-budget", BordaBudgetController)

import WeightedPollController from './weighted_poll_controller'
application.register("weighted-poll", WeightedPollController)

import QuizNestedFormController from './quiz_nested_form_controller'
application.register("quiz-nested-form", QuizNestedFormController)

import QuestionRightAnswerController from './question_right_answer_controller'
application.register("question-right-answer", QuestionRightAnswerController)

import QuizSliderController from './quiz_slider_controller'
application.register("quiz-slider", QuizSliderController)

import QuizResultController from './quiz_result_controller'
application.register("quiz-result", QuizResultController)

import QuizDashboardTimerController from './quiz_dashboard_timer_controller'
application.register("quiz-dashboard-timer", QuizDashboardTimerController)

import QuizDashboardSliderController from './quiz_dashboard_slider_controller'
application.register("quiz-dashboard-slider", QuizDashboardSliderController)

import QuizDashboardChannelController from './quiz_dashboard_channel_controller'
application.register("quiz-dashboard-channel", QuizDashboardChannelController)

import QuizUserChannelController from './quiz_user_channel_controller'
application.register("quiz-user-channel", QuizUserChannelController)

import QuestionDashboardRankController from './question_dashboard_rank_controller'
application.register("question-dashboard-rank", QuestionDashboardRankController)

import QuestionDashboardController from './question_dashboard_controller'
application.register("question-dashboard", QuestionDashboardController)

import QuestionRankController from './question_rank_controller'
application.register("question-rank", QuestionRankController)

import QuestionUserController from './question_user_controller'
application.register("question-user", QuestionUserController)

import QuizFinalRankController from './quiz_final_rank_controller'
application.register("quiz-final-rank", QuizFinalRankController)

import QuizDashboardFinalRankController from './quiz_dashboard_final_rank_controller'
application.register("quiz-dashboard-final-rank", QuizDashboardFinalRankController)

import ToggleController from './toggle_controller'
application.register("toggle", ToggleController)

import NetworkController from "./network_controller"
application.register("network", NetworkController)

import NetworkDashboardController from "./network_dashboard_controller"
application.register("network-dashboard", NetworkDashboardController)

import ChangeController from './change_controller'
application.register("change", ChangeController)

import CheckedController from "./checked_controller"
application.register("checked", CheckedController)

import BattleDashboardController from './battle_dashboard_controller'
application.register("battle-dashboard", BattleDashboardController);

import CommentController from './comment_controller'
application.register("comment", CommentController);

import ImageViewerController from './image_viewer_controller'
application.register("image-viewer", ImageViewerController);

import ReserveaheadController from './reserveahead_controller'
application.register("reserveahead", ReserveaheadController);

import ReservationController from './reservation_controller'
application.register("reservation", ReservationController);

import CarouselController from './carousel_controller'
application.register("carousel", CarouselController);